import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Skeleton, Pagination } from "antd";
import Loader from "../components/Loader";
import SearchBox from "../components/SearchBox";
import { useProductContext } from "../context/ProductContext";


const Product = () => {
    const [productBanner, setProductBanner] = useState(null);
    const { prod, loading } = useProductContext();

    const [filters, setFilters] = useState({
        brand: "",
        brandCategory: "",
        category: "",
        fuelEfficiency: "",
        season: "",
        wetGrip: "",
        snowGrip: ""
    });
    const [showResults, setShowResults] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingState, setLoadingState] = useState(false);

    const pageSize = 8;

    const filteredProducts = useMemo(() => {
        if (!showResults) return prod;
        return prod.filter((p) => {
            const attr = p.Attributes || {};
            return (
                (!filters.brand || attr.Brand === filters.brand) &&
                (!filters.brandCategory || attr.BrandCategory === filters.brandCategory) &&
                (!filters.category || attr.Category === filters.category) &&
                (!filters.fuelEfficiency || attr.FuelEfficiencyRating === filters.fuelEfficiency) &&
                (!filters.season || attr.Season === filters.season) &&
                (!filters.wetGrip || attr.WetGripRating === filters.wetGrip) &&
                (!filters.snowGrip || (filters.snowGrip === "Yes" ? attr.SnowGrip : !attr.SnowGrip))
            );
        });
    }, [prod, filters, showResults]);

    const startIndex = (currentPage - 1) * pageSize;
    const currentProducts = filteredProducts.slice(startIndex, startIndex + pageSize);

    useEffect(() => {
        if (showResults) {
            const section = document.querySelector('.product-list-wrapper');
            if (section) {
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            setLoadingState(true);
            const timer = setTimeout(() => setLoadingState(false), 500);
            return () => clearTimeout(timer);
        }
    }, [filters, currentPage, showResults]);

    const getProductBanner = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}get-content/ProductPageBanner`);
            setProductBanner(res.data.data[0]);
        } catch (err) {
            console.error("Error fetching Banner Content:", err);
        }
    };

    useEffect(() => {
        getProductBanner();
    }, []);

    const handleTop = (e) => {
        e.preventDefault();
        const section = document.querySelector('.product_search_wrpr');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    if (productBanner === null) return <Loader />;

    const renderSkeleton = () => (
        <div className="container-fluid web-padding">
            <div className="row">
                {Array.from({ length: 8 }).map((_, i) => (
                    <div className="col-md-3" key={i}>
                        <div className="p-3 border rounded-md shadow-sm mb-4">
                            <Skeleton.Image active style={{ width: "100%", height: 300, marginBottom: '20px', display: "flex" }} />
                            <Skeleton active paragraph={{ rows: 3 }} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <>
            <section className="inner-banner"
                style={{ backgroundImage: `url(${process.env.REACT_APP_SITE_IMAGES}${productBanner.image_2})` }}>
                <div className="container-fluid web-padding">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="inner-banner-left">
                                <h1>{productBanner.title}</h1>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="inner-banner-right">
                                <img src={`${process.env.REACT_APP_SITE_IMAGES}${productBanner.image}`} alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
                <h2>Tyres</h2>
            </section>
            <SearchBox filters={filters} setFilters={setFilters} setShowResults={setShowResults} />
            <div className="product-list-wrapper">
                <section className="our-products">
                    <h2 className="text-center mb-4">All Products</h2>
                    {loading || loadingState ? (
                        renderSkeleton()
                    ) : (
                        <div className="container-fluid web-padding">
                            <div className="row" data-aos="fade-up" data-aos-duration={1000}>
                                {currentProducts.length > 0 ? (
                                    currentProducts.map((tyre, index) => (
                                        <div className="col-md-3" key={index}>
                                            <div className="featured-card mb-4">
                                                <Link to={`/product/${tyre.ProductCode}`}>
                                                    <div className="featured-card-img">
                                                        <img src="/images/feature01.png" alt="tyre" />
                                                    </div>
                                                    <div className="featured-card-wrapper">
                                                        <div className="featured-card-content">
                                                            <h5>{tyre.DescriptionShort}</h5>
                                                            <p>
                                                                Brand: <strong>{tyre.Attributes?.Brand}</strong><br />
                                                                Wet Grip: <strong>{tyre.Attributes?.WetGripRating}</strong><br />
                                                                Fuel Efficiency: <strong>{tyre.Attributes?.FuelEfficiencyRating}</strong>
                                                            </p>
                                                            <h5>£{tyre.VATBondPrice}</h5>
                                                        </div>
                                                        <div className="featured-card-icon">
                                                            <img src="/images/arrow-right.png" alt="arrow" />
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="not_found m-auto">
                                        {filters.brand ||
                                            filters.brandCategory ||
                                            filters.category ||
                                            filters.fuelEfficiency ||
                                            filters.season ||
                                            filters.wetGrip ||
                                            filters.snowGrip ? (
                                            <>No products found for your selection.</>
                                        ) : (
                                            <>
                                                No products found. Please Enter Tyre Size!
                                                <a href="#" onClick={handleTop}>
                                                    <i className="fa-solid fa-arrow-up"></i>
                                                </a>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                            {filteredProducts.length > pageSize && (
                                <div className="row pagination-row">
                                    <div className="col-md-12">
                                        <div className="pagination-wrapper text-center">
                                            <Pagination
                                                current={currentPage}
                                                pageSize={pageSize}
                                                total={filteredProducts.length}
                                                showSizeChanger={false}
                                                onChange={(page) => setCurrentPage(page)}
                                                showLessItems
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </section>
            </div>
        </>
    );
};

export default Product;
